<h2 mat-dialog-title align="center" *ngIf="data.title">{{data.title}}</h2>
<div mat-dialog-content>
    <table style="padding:10px">
        <tr>
            <td><app-progress></app-progress></td>
            <td>{{data.message}}</td>
        </tr>
    </table>
</div>
